module.exports = __webpack_public_path__ + "static/media/cam_4.5ab18e35.webp";